import { RefObject } from 'react'

import {
  Floors,
  Options,
  PyeongSizes,
  PropertyTypes,
  RoomCounts,
  RoomDiscounts,
  UsingFee,
  FilterStoreProvider,
  ResetButton,
} from '@/features/room-filter'
import { cn, MultiScrollProvider } from '@/shared/lib'
import { Separator, Spinner } from '@/shared/ui'

type Props = {
  isLoading: boolean
  stuck?: boolean
  ref?: RefObject<HTMLDivElement | null>
}

export const Filter = ({ isLoading, stuck, ref }: Props) => {
  return (
    <MultiScrollProvider>
      <FilterStoreProvider>
        <div ref={ref} className="flex w-[296px] flex-col">
          <div className="flex flex-row items-center justify-between px-5 pt-10 pb-[29px]">
            <h2 className="typo-headline2 font-semibold text-black">필터</h2>
            <ResetButton />
          </div>

          <Separator orientation="horizontal" />

          <div className="relative flex min-h-75 pt-10 pb-6">
            {isLoading ? (
              <Spinner />
            ) : (
              <div
                className={cn(
                  'scrollbar gutter-stable thick w-full space-y-6 overflow-y-auto pr-1.5 pl-5',
                  stuck && 'h-[calc(100vh-164px)]',
                )}
              >
                <RoomCounts />
                <UsingFee />
                <PropertyTypes />
                <PyeongSizes />
                <Floors />
                <Options />
                <RoomDiscounts />
              </div>
            )}
          </div>
        </div>
      </FilterStoreProvider>
    </MultiScrollProvider>
  )
}
